"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../../");
var utils_1 = require("../../../utils/");
var Model_1 = require("../../Model");
var TRAFFIC_SPEEDS;
(function (TRAFFIC_SPEEDS) {
    TRAFFIC_SPEEDS["SPEED_FASTER"] = "faster";
    TRAFFIC_SPEEDS["SPEED_FAST"] = "fast";
    TRAFFIC_SPEEDS["SPEED_NORMAL"] = "normal";
    TRAFFIC_SPEEDS["SPEED_SLOW"] = "slow";
    TRAFFIC_SPEEDS["SPEED_VERY_SLOW"] = "very slow";
})(TRAFFIC_SPEEDS = exports.TRAFFIC_SPEEDS || (exports.TRAFFIC_SPEEDS = {}));
exports.checkIfPropertyIsSet = function (name, fullObject, property) {
    if (typeof property === 'undefined') {
        if (typeof fullObject === 'undefined') {
            utils_1.logger.error("Can't extract " + name + " in " + __filename + ", because object is undefined", fullObject);
            throw new Error("Can't extract " + name + ", object is undefined");
        }
        return;
    }
    if (typeof fullObject[property] === "undefined") {
        utils_1.logger.error("Can't extract " + name + " in " + __filename + ",\n       because there is no " + property + " found on the " + name, fullObject);
        throw new Error("Can't extract " + name + ", property " + property + " not set");
    }
};
exports.extractDriver = function (driver) { return __awaiter(_this, void 0, void 0, function () {
    var resolved;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, driver];
            case 1:
                resolved = _a.sent();
                exports.checkIfPropertyIsSet("driver", resolved, "getActive");
                exports.checkIfPropertyIsSet("driver", resolved, "getId");
                exports.checkIfPropertyIsSet("driver", resolved, "getName");
                return [2 /*return*/, {
                        active: resolved.getActive,
                        id: resolved.getId,
                        name: resolved.getName,
                    }];
        }
    });
}); };
exports.extractSubcontractor = function (subcontractor) { return __awaiter(_this, void 0, void 0, function () {
    var _a, location, drivers, driversExtracted;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                exports.checkIfPropertyIsSet("subco", subcontractor, "getId");
                exports.checkIfPropertyIsSet("subco", subcontractor, "getName");
                return [4 /*yield*/, Promise.all([subcontractor.getLocation, subcontractor.getDrivers])];
            case 1:
                _a = _b.sent(), location = _a[0], drivers = _a[1];
                return [4 /*yield*/, Promise.all(drivers.map(exports.extractDriver))];
            case 2:
                driversExtracted = _b.sent();
                return [2 /*return*/, {
                        drivers: driversExtracted,
                        id: subcontractor.getId,
                        location: location,
                        name: subcontractor.getName,
                    }];
        }
    });
}); };
exports.generateRoutes = function (shipments, subcontractor, options) { return __awaiter(_this, void 0, void 0, function () {
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_a = __1.Tour).makeRequest;
                _c = ["/spatial/functions/optimize-routes", Model_1.METHOD.POST];
                _d = {
                    options: options,
                    shipments: shipments
                };
                return [4 /*yield*/, exports.extractSubcontractor(subcontractor)];
            case 1: return [2 /*return*/, _b.apply(_a, _c.concat([(_d.subcontractor = _e.sent(),
                        _d)]))];
        }
    });
}); };
